module.exports = __webpack_public_path__ + "static/media/aipassLogo.e4099f51.svg";